import React from 'react';
import PropTypes from 'prop-types';
import FieldValidator from '../FieldValidator/FieldValidator';
import PickerSelect from './PickerSelect';

const PickerSelectValidator = props => {
  const { values, name, defaultValue } = props;
  values[name] = values[name] || defaultValue;

  return <FieldValidator {...props} fieldComponent={PickerSelect} />;
};

PickerSelectValidator.propTypes = {
  values: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PickerSelectValidator;
